import script from "./UploadersComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadersComponent.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__